<script>
import api from '@/api/taskReminder';

import BasePopup from '@/components/BasePopup.vue';
import utils from '@/utils/common';
import BaseSelect from '@/components/BaseSelect.vue';
import BaseDatepicker from '@/components/BaseDatepicker.vue';

export default {
  name: 'TaskReminder',
  components: { BaseSelect, BaseDatepicker, BasePopup },
  props: {
    task: Object,
  },
  data() {
    return {
      isOpened: false,
      editable: null,
      items: [],
    };
  },
  computed: {
    targetOptions() {
      return {
        self: 'Себе',
        author: 'Автору',
        manager: 'Ответственному',
        members: 'Наблюдателям',
        all: 'Всем',
      };
    },
  },
  methods: {
    async open() {
      const res = await api.fetchList({ task: this.task.id }, true);
      this.items = res.items;
      this.editable = null;
      this.isOpened = true;
    },
    close() {
      this.isOpened = false;
    },
    formatDate(date) {
      return utils.convertDateToString(new Date(date), 'long', true);
    },
    formatTarget(target) {
      return this.targetOptions[target] ?? '';
    },
    add() {
      this.editable = {
        target: 'self',
        notifyAt: null,
      };

      this.items.push(this.editable);
    },
    async save() {
      const data = {
        task: this.task['@id'],
        notifyAt: this.editable.notifyAt,
        target: this.editable.target,
      };

      // eslint-disable-next-line
      this.editable.id
        ? await api.update(this.editable.id, data, true)
        : await api.create(data, true);

      await this.open();
      this.editable = null;
    },
    cancel() {
      if (!this.editable.id) {
        this.items = this.items.filter(r => r !== this.editable);
      }

      this.editable = null;
    },
    async remove(item) {
      if (!await this.$confirm('Удалить напоминание?')) return;

      await api.delete(item.id, true);
      await this.open();
    },
  },
};
</script>

<template lang="pug">
  .b-task-reminder
    button._main-btn(@click="open")
      Icon(name="notifications" colored pointer)
      | Напомнить
    BasePopup(v-if="isOpened" @close="close")
      ._popup-content
        ._title Напоминания
        ._list
          div(v-if="!items.length")
          template(v-else)
            template(v-for="item in items")
              form._form(v-if="item === editable" @submi.prevent="save")
                BaseSelect(v-model="editable.target" :options="targetOptions" hideNotSelected)
                BaseDatepicker(v-model="editable.notifyAt" type="datetime")
                Btn._save(green :disabled="!editable.notifyAt" @click="save")
                  Icon(name="check-green" colored pointer)
                Btn._cancel(grey @click="cancel")
                  Icon(name="close-green" colored pointer)
              ._item(v-else :class="{ isFulfilled: item.isFulfilled }")
                ._target {{ formatTarget(item.target) }}
                ._notify-at {{ formatDate(item.notifyAt) }}
                button._edit(v-if="!item.isFulfilled" @click="editable=item")
                  Icon(name="edit" pointer colored)
                ._edit(v-else)
                button._delete(@click="remove(item)")
                  Icon(name="trash" pointer colored)
        ._footer
          Btn(v-if="!editable" sm dark @click="add")
            Icon(name="plus" pointer)
            | Добавить
</template>

<style scoped lang="scss">
.task-reminder {
  &__main-btn {
    background: transparent;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #788CA1;
    font-size: 15px;
    text-decoration: underline dotted;
    text-underline-offset: 3px;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }

    svg {
      color: #FFC531;
      height: 20px;
      width: auto;
    }
  }

  &__popup-content {
    width: 550px;
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 30px;
  }

  &__form {
    margin-bottom: 15px;
  }

  &__form {
    display: grid;
    grid-template-columns: 1fr 1fr 38px 38px;
    gap: 20px;
    align-items: stretch;
  }

  &__save, &__cancel {
    padding: 0;
    aspect-ratio: 1;
    height: 38px;

    svg {
      width: 15px;
      height: 15px;
    }
  }

  &__save svg {
    color: #fff;
  }

  &__cancel svg {
    color: #92A0B0;
  }

  &__list {
    margin-bottom: 20px;
  }

  &__item {
    display: grid;
    grid-template-columns: 1fr 2fr 14px 14px;
    gap: 12px;
    margin-bottom: 10px;

    &.isFulfilled {
      opacity: 0.4;
    }
  }

  &__target {
    font-size: 14px;
    color: #1E3147;
  }

  &__notify-at {
    font-size: 12px;
    color: #788CA1;
  }

  &__edit, &__delete {
    background: transparent;

    svg {
      color: #788CA1;
    }
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 768px) {
    &__popup-content {
      width: 70vw;
    }

    &__form {
      grid-template-columns: 1fr 38px 38px;

      & > *:first-child {
        grid-column:  1 / 3 span;
      }
    }

    &__item {
      grid-template-columns: 1fr 14px 14px;
      row-gap: 2px;
      margin-bottom: 15px;
    }

    &__notify-at {
      grid-row: 2;
    }

    &__edit, &__delete {
      grid-row: 1 / 2 span;
    }
  }
}
</style>
